import { render, staticRenderFns } from "./SlideDeck.vue?vue&type=template&id=1081ba14&scoped=true"
import script from "./SlideDeck.vue?vue&type=script&lang=ts"
export * from "./SlideDeck.vue?vue&type=script&lang=ts"
import style0 from "./SlideDeck.vue?vue&type=style&index=0&id=1081ba14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1081ba14",
  null
  
)

export default component.exports